import { defineStore } from 'pinia'
import { ref } from 'vue'
import { isEmptyObject, isBoolean } from '@/utils/is'

export const useTemCache = defineStore('temCache', () => {
  const data = ref<any>({})
  function saveData(key: string, msg: any) {
    data.value[key] = msg
  }
  function getData(key: string) {
    if (isBoolean(data.value[key])) return data.value[key]
    if (isEmptyObject(data.value[key])) return false
    return data.value[key]
  }
  function removeData(key: string) {
    data.value[key] = {}
  }
  function clearData() {
    data.value = {}
  }
  function removeAppointData(info: Object) {
    for (const key in info) {
      data.value[key] = {}
    }
  }

  return { data, saveData, getData, removeData, clearData, removeAppointData }
})
